<template>
  <div>
    <v-layout column wrap>
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h5 class="font-weight-light">LIST OF BRANCHES</h5>
          </v-toolbar-title>
        </v-toolbar>
        <list-of-branches/>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
  import {
    mdiAccountGroup
    , mdiAccountSearch
  } from '@mdi/js'
  import {mapActions, mapGetters} from "vuex";
  import ListOfBranches
    from "@/views/register_interface/branch_component/ListOfBranches";

  export default {
    components: {
      ListOfBranches,
    },
    data() {
      return {
        icons: {
          mdiAccountGroup,
          mdiAccountSearch,
        },
      }
    },
  }
</script>
